// extracted by mini-css-extract-plugin
export var hidden = "_uz-0";